export const config = {
  appConfigId: process.env.REACT_APP_LOCAL_APP_CONFIG_ID,
  credentialId: process.env.REACT_APP_LOCAL_CREDENTIAL_ID,
  identityProviderType: "urn:scrn:auth:oauth2/microsoft/powerbi/v2.0",
  pageName: process.env.REACT_APP_LOCAL_PAGE_NAME,
  pageTime: parseInt(process.env.REACT_APP_LOCAL_PAGE_TIME, 10),
  reportId: process.env.REACT_APP_LOCAL_REPORT_ID,
  reportName: process.env.REACT_APP_LOCAL_REPORT_NAME,
  reportType: process.env.REACT_APP_LOCAL_REPORT_TYPE,
  urlFilter: process.env.REACT_APP_LOCAL_URL_FILTER,
  filters: process.env.REACT_APP_LOCAL_FILTERS,
  refreshMilliseconds: parseInt(
    process.env.REACT_APP_LOCAL_REFRESH_MILLISECONDS,
    10
  ),
  username: process.env.REACT_APP_LOCAL_USERNAME,
  workspaceId: process.env.REACT_APP_LOCAL_WORKSPACE_ID,
};
